// import 'babel-polyfill'
import 'core-js/stable'; // only stable feature also is possible with only `core-js`
import 'regenerator-runtime/runtime'; // T
import axios from 'axios'
import Vue from 'vue'

import MapView from './MapView.vue'
import { load } from './loader'

new Vue({
    components: { MapView },
    mounted () {
        load()
    },
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js